
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login/reset",
      function () {
        return require("private-next-pages/login/reset.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/login/reset"])
      });
    }
  